module.exports = __webpack_public_path__ + "img/prod_img_material.e9d72d21.png";